<script>
import { connect } from 'vuex-connect';
import CallHelpBtn from '@/launcher/components/shared/CallHelpBtn';

export default connect({
  gettersToProps: {
    hasCalledHelp: 'hasCalledHelp',
    disabled: 'safetyMode',
  },
  actionsToEvents: {
    'call-help': 'callHelp',
    'cancel-help': 'cancelHelp',
  },
})('CallHelpBtn', CallHelpBtn);
</script>
